import { render, staticRenderFns } from "./student_works.vue?vue&type=template&id=276021c1&scoped=true&"
import script from "./student_works.vue?vue&type=script&lang=js&"
export * from "./student_works.vue?vue&type=script&lang=js&"
import style0 from "./student_works.vue?vue&type=style&index=0&id=276021c1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276021c1",
  null
  
)

export default component.exports